import { getMangoApiClient } from '~/atoms/MangoApi'

import { createSoundClipApi } from '@mangovoice/soundclips-ui'

export const soundClipApi = createSoundClipApi(
  getMangoApiClient().soundClips.transport,
)
